import { AppLanguage } from './../../language';
import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '../store';

@Module({
  dynamic: true,
  name: 'language',
  store,
})
class LanguageModule extends VuexModule {

  // State
  _language: AppLanguage = 'en';

  // Accessors
  get language() {
    return this._language;
  }

  // MARK: Mutations
  @Mutation
  setLanguage(language: AppLanguage) {
    this._language = language;
  }

}

export default getModule(LanguageModule);
